<template>
    <app-layout v-if="isPageReady">
        <div class="appVersion visHidden">
            {{ appVersion }}
        </div>
        <common-content-spacer height="medium-small">
            <workboard></workboard>

            <common-notification
                ref="commonSuccessNotificationChild"
                :content="$t('elements.home.invitations_sent.successful')"
            ></common-notification>

            <common-grid class="widget__container widget__min-height" justify="space-between">
                <common-grid-column class="widget__min-width" :width="7">
                    <index-home-rating :professionalRating="getActiveMemberRating" :rating="getRating"></index-home-rating>
                </common-grid-column>

                <common-grid-column v-if="!isTabletSmall" :width="8">
                    <index-members-nearby></index-members-nearby>
                </common-grid-column>

                <common-grid-column class="widget__min-width" :width="7">
                    <index-pending-connections></index-pending-connections>
                </common-grid-column>
            </common-grid>

            <referrals-analytic-overview v-if="isAllowedToSeeAnalyticReport && !isTablet"></referrals-analytic-overview>
        </common-content-spacer>
        <virtual-assistant v-if="isRedirectionBoxVisible" @close-redirection="toggleRedirectionBox"></virtual-assistant>
        <div v-if="!isTablet" class="virtual-assistant-icon">
            <common-icon :name="chatBotName" size="gigantic" @click="toggleRedirectionBox"></common-icon>
        </div>
    </app-layout>
</template>

<script>
    import Store from '@/store'
    import MessagesAPI from 'api/MessagesAPI'
    import PageWithTitleMixin from 'mixins/PageWithTitleMixin'
    import PageWithElementsMixin from 'mixins/PageWithElementsMixin'
    import PageWithDataMixin from 'mixins/PageWithDataMixin'
    import AppLayout from 'components/layouts/AppLayout'
    import Workboard from 'components/page-elements/index/workboard/Workboard'
    import ReferralsAnalyticOverview from 'components/page-elements/referrals-overview/ReferralsAnalyticOverview'
    import IndexPendingConnections from 'components/page-elements/index/IndexPendingConnections'
    import IndexMembersNearby from 'components/page-elements/index/IndexMembersNearby'
    import { version } from '../../../package.json'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'
    import ScreenSizeDetectionMixin from 'mixins/ScreenSizeDetectionMixin'
    import VirtualAssistant from 'pages/index/virtual-assistant/VirtualAssistant'

    export default {
        mixins: [PageWithTitleMixin, PageWithElementsMixin, PageWithDataMixin, ScreenSizeDetectionMixin],

        components: {
            AppLayout,
            IndexPendingConnections,
            Workboard,
            IndexMembersNearby,
            ReferralsAnalyticOverview,
            VirtualAssistant,
        },

        data() {
            return {
                userId: null,
                connections: [],
                PracticeTypeEnum: PracticeTypeEnum,
                isRedirectionBoxVisible: false,
                chatBotName: 'chat-bot-down',
            }
        },

        computed: {
            isAllowedToSeeAnalyticReport() {
                return this.$auth.getActiveMember()?.isMasterUser
            },

            pageTitle() {
                return this.$t('pages.index.home.title')
            },

            appVersion() {
                return version
            },

            getRating() {
                return this.$auth.getPractice().practiceType === PracticeTypeEnum.ANCILLARY
                    ? this.$auth.getPractice()?.rating
                    : this.$auth.getActiveMember()?.rating
            },

            getActiveMemberRating() {
                return this.$auth.getActiveMember()?.professionalRating
            },
        },

        methods: {
            getUnreadMessages() {
                if (!this.userId) return
                const _fields = ['id']
                const query = {
                    toUserId:
                        this.$auth.getPractice().practiceType === this.PracticeTypeEnum.ANCILLARY ? 0 : this.$auth.getUser().id,
                    toPracticeId: this.$auth.getPractice().id,
                }
                MessagesAPI.getUnread(query, _fields).then((resp) => {
                    Store.dispatch('chat-messages/setUnread', resp)
                })
            },

            toggleRedirectionBox() {
                this.isRedirectionBoxVisible = !this.isRedirectionBoxVisible
                if (this.isRedirectionBoxVisible) {
                    this.chatBotName = 'chat-bot'
                } else {
                    this.chatBotName = 'chat-bot-down'
                }
                window.scrollTo(0, 0)
            },
        },

        mounted() {
            this.userId = this.$auth.getUser().id
            if (!localStorage.getItem('showRedirectionBox') && !this.isTablet) {
                this.isRedirectionBoxVisible = true
            }
            if (!this.$auth.isUserPracticeOther()) {
                this.getUnreadMessages()
            }
        },
    }
</script>

<style lang="scss">
    .virtual-assistant-icon {
        position: absolute;
        bottom: -80px;
        right: 0;

        .icon {
            cursor: pointer;
            width: 90px;
            height: 90px;
            svg {
                display: block;
                width: auto;
                height: 100px;
                width: 100px;
            }
        }
    }
</style>
